import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=23a8ad98&scoped=true&"
import script from "./issues.vue?vue&type=script&lang=js&"
export * from "./issues.vue?vue&type=script&lang=js&"
import style0 from "./issues.vue?vue&type=style&index=0&id=23a8ad98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8ad98",
  null
  
)

component.options.__file = "issues.vue"
export default component.exports